const content = {
  brand: 'Building Blox',
  domain: 'getablox.com',
  tagline: 'Purpose-built spaces in development.',
  studioUrl: 'https://jstewdios.com',
  studioLabel: 'jstewdios.com',
  year: new Date().getFullYear(),

  meta: {
    title: 'Building Blox — Small spaces. Built for big purposes.',
    description:
      'Building Blox designs compact, purpose-built spaces that can be transported and installed where needed. Follow the build at getablox.com.',
    url: 'https://getablox.com',
    ogImage: '/og-share.png',
  },

  nav: [
    { label: 'The Idea', href: '#idea' },
    { label: 'Blox', href: '#blox' },
    { label: 'Updates', href: '#updates' },
  ],

  hero: {
    headline: 'Small spaces. Built for big purposes.',
    support:
      'Building Blox creates compact, purpose-built spaces for working, growing, relaxing, creating, and living.',
    primaryCta: { label: 'Follow the build', href: '#updates' },
    secondaryCta: { label: 'Explore the idea', href: '#idea' },
    // Swap this path when a final product render is ready
    image: '/img/hero-blox.png',
    imageAlt:
      'Concept render of a compact charcoal modular building with cedar accents',
  },

  concept: {
    id: 'idea',
    headline: 'A better building block',
    body:
      'Building Blox is exploring a family of transportable structures designed around specific uses—rather than forcing every customer into the same empty box.',
    points: [
      {
        title: 'Purpose-built interiors',
        text: 'Each concept is planned for a clear job, not left as a blank shell.',
      },
      {
        title: 'Compact footprints',
        text: 'Small enough to move and place where they are actually needed.',
      },
      {
        title: 'Durable construction',
        text: 'Built to feel solid, finished, and ready for real use outdoors.',
      },
      {
        title: 'Expandable product family',
        text: 'A growing set of Blox for growing, working, resting, and creating.',
      },
      {
        title: 'Finished product, not a trailer',
        text: 'Designed as a complete space—not a temporary construction box.',
      },
    ],
  },

  blox: {
    id: 'blox',
    headline: 'Blox in development',
    intro:
      'These concepts show the direction of the product family. None are available to order yet.',
    items: [
      {
        id: 'grow',
        name: 'Grow Blox',
        description:
          'A compact controlled environment for growing food and plants.',
        status: 'Concept',
        featured: true,
        image: '/img/grow-blox.png',
      },
      {
        id: 'work',
        name: 'Work Blox',
        description: 'A focused workshop, office, or production space.',
        status: 'Concept',
        featured: false,
        image: '/img/workblox.webp',
      },
      {
        id: 'hot',
        name: 'Hot Blox',
        description: 'A private sauna and outdoor wellness retreat.',
        status: 'Concept',
        featured: false,
        image: '/img/hotblox.webp',
      },
      {
        id: 'beat',
        name: 'Beat Blox',
        description:
          'A dedicated space for recording, practicing, and creating music.',
        status: 'Concept',
        featured: false,
        image: '/img/beatblox.webp',
      },
    ],
  },

  direction: {
    id: 'direction',
    badge: 'In development',
    headline: 'Starting with Grow Blox',
    body:
      'The first Building Blox concept is a compact growing environment designed to make year-round cultivation simpler, cleaner, and easier to control.',
  },

  signup: {
    id: 'updates',
    headline: 'See what gets built',
    body:
      'Get occasional progress updates, product concepts, and early availability announcements. No constant marketing.',
    emailLabel: 'Email address',
    emailPlaceholder: 'you@example.com',
    interestLabel: 'I’m most interested in',
    interests: [
      { value: 'grow', label: 'Grow Blox' },
      { value: 'work', label: 'Work Blox' },
      { value: 'hot', label: 'Hot Blox' },
      { value: 'beat', label: 'Beat Blox' },
      { value: 'general', label: 'General updates' },
    ],
    button: 'Keep me posted',
    success:
      'Thanks — you’re on the list. We’ll share progress as things take shape.',
    error:
      'Something went wrong. Please try again, or email us directly if it continues.',
    /**
     * Email integration:
     * - With root server: REACT_APP_SIGNUP_ENDPOINT=/api/subscribe
     * - Or Formspree / Buttondown / custom API URL
     * Expected POST body: { email, interest }
     * Empty string = local placeholder (logs payload, shows success for UI testing)
     */
    endpoint: process.env.REACT_APP_SIGNUP_ENDPOINT || '',
  },
};

export default content;
